export default __webpack_public_path__ + "static/media/createBill-icon.2bf8290e.svg";